export default __webpack_public_path__ + "static/media/careteam_sidemenu_ticket.a50ed336.svg";